import React from 'react';
import { inject, observer } from 'mobx-react';
import WorkflowStepBaseComponent from './workflow-step-base';
import moment from 'moment';

@inject('appStore')
@observer
export default class ConfirmReadTextStep extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
    }

    handleSend() {
        const now = moment.utc();
        const step = this.props.step;
        step.state.isComplete = true;
        step.state.data.timeStamp = now.format();
        step.state.data.message = `${this.props.confirmMessage} on ${now.local().format('llll')}`;

        // this.props.appStore.analytics.track("Workflow Step Submitted", { step:this.props.step })

        this.updateStepState(step);
    }

    renderCompleteView(step) {
        return <span>{step.state.data.message}</span>;
    }

    renderIncompleteView(step) {
        return (
            <div>
                {this.props.incompleteContent}
                <p>
                    <button className="btn btn-primary pull-right" onClick={this.handleSend.bind(this)}>
                        {this.props.actionButtonText}
                    </button>
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/confirm-read-text-step.js